import React from 'react';
import { Group, ToastReference, useToast } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import internalApiClient from '../../../../../shared/util/api/internalApiClient';
import FileUploadButton from '../../../../../shared/components/FileUploadButton';

const validateFiles = (file: File | null) => {
    if (file === null) {
        return t`Master data file is required`;
    }
    if (file.type !== 'text/xml') {
        return t`File must be of XML format`;
    }

    return null;
};

export default function OtherCompanyInfoContent({ closeDialog }) {
    const toast = useToast();
    const [fileInputKey, remountFileInput] = React.useReducer(v => v + 1, 0);

    async function handleFileUpload(selectedFiles: FileList | null) {
        if (!selectedFiles?.[0]) {
            return;
        }

        const file = selectedFiles[0];
        const fileValidationError = validateFiles(file);
        let toastRef: ToastReference | null = null;

        try {
            if (fileValidationError !== null) {
                throw new Error(fileValidationError);
            }

            toastRef = toast.loading(t`Uploading file`);

            const data = new FormData();
            data.append('files[]', file, file.name);

            const request = {
                url: 'company/import-saft-xml',
                data,
                config: {
                    headers: { Accept: 'text/xml; charset=utf-8' },
                },
            };

            const response = await internalApiClient.post(request.url, request.data, request.config);

            if (response.status && response.status === 200) {
                toastRef.success(t`File successfully uploaded`);
            } else {
                toastRef.error(response.data.message);
            }
        } catch (error: any) {
            if (Array.isArray(error.response.data[''])) {
                toastRef?.error(error?.response?.data[''][0]);
            }
            toastRef?.error(t`Error when uploading the file`);
        } finally {
            remountFileInput();
            closeDialog();
        }
    }

    return (
        <Group>
            <FileUploadButton
                appearance="primary"
                acceptedFileTypes={['text/xml']}
                fileInputKey={fileInputKey}
                onFileSelect={handleFileUpload}>
                <Trans>Import master data</Trans>
            </FileUploadButton>
        </Group>
    );
}
